const STORAGE_KEY = "prepnexis_first_touch_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const canUseBrowserStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const readStoredAttribution = () => {
  if (!canUseBrowserStorage()) return null;

  try {
    const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    return value && typeof value === "object" && !Array.isArray(value) ? value : null;
  } catch {
    return null;
  }
};

export const captureFirstTouchAttribution = () => {
  const existing = readStoredAttribution();
  if (existing) return existing;
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams(window.location.search);
  const attribution = UTM_KEYS.reduce((result, key) => {
    const value = params.get(key)?.trim();
    if (value) result[key] = value.slice(0, 200);
    return result;
  }, {});

  if (document.referrer) attribution.referrer = document.referrer.slice(0, 2048);
  attribution.initial_landing_page = `${window.location.origin}${window.location.pathname}`.slice(0, 2048);

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch {
    // Attribution is helpful but must never interrupt signup.
  }
  return attribution;
};

export const getFirstTouchAttribution = () =>
  readStoredAttribution() || captureFirstTouchAttribution();

export const clearFirstTouchAttribution = () => {
  if (!canUseBrowserStorage()) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be unavailable in privacy-restricted browser contexts.
  }
};
